const DECIMAL_DISPLAY_PATTERN = /^[+-]?(?:\d+(?:\.\d*)?|\.\d+)(?:[eE][+-]?\d+)?$/;
const DECIMAL_INPUT_PATTERN = /^[+-]?(?:\d+(?:[.,]\d*)?|[.,]\d+)(?:[eE][+-]?\d+)?$/;

export function formatGermanDecimalValue(value: unknown): string {
    const raw = String(value ?? '');
    return DECIMAL_DISPLAY_PATTERN.test(raw) ? raw.replace('.', ',') : raw;
}

/** Returns an empty string for a cleared value and null when the input is invalid. */
export function parseGermanDecimalValue(value: unknown): string | null {
    if (value == null || value === '') return '';
    const raw = String(value).trim();
    if (!DECIMAL_INPUT_PATTERN.test(raw)) return null;
    return raw.replace(',', '.');
}
